import React, { Component } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  HashRouter,
  Redirect,
} from "react-router-dom";
import AirQuality from "./containers/aq-container";
import Barrage from "./containers/bg-container";
import WeatherRauki from "./containers/WeatherCard/Components/WeatherRauki";
import WeatherPasha from "./containers/WeatherCard/Components/WeatherPasha";

import Energy from "./containers/energy-container";
import Home from "./components/home";
// import { getdata } from './getAlerts';
//import './scss/style.css'
import store from "./store";
import withClearCache from "./ClearCache";

class MainApp extends Component {
  componentDidMount() {
    store.dispatch({
      type: "CONNECT",
    });

    // getdata();
  }
  render() {
    let selectedFarm = "PASHA"; // default fallback

    function loadPublicEnv() {
      try {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", "/config.env", false); // synchronous to ensure it loads before app runs
        xhr.send();
    
        if (xhr.status === 200) {
          const envText = xhr.responseText;
          const lines = envText.split("\n");
    
          lines.forEach(line => {
            const trimmed = line.trim();
            if (!trimmed || trimmed.startsWith("#")) return; // skip empty or comment lines
            const [key, value] = trimmed.split("=");
            if (key && value) {
              if (key.trim() === "REACT_APP_SELECTED_FARMS") {
                selectedFarm = value.trim();
              }
            }
          });
        } else {
          console.error("❌ Failed to load config.env file:", xhr.status);
        }
      } catch (err) {
        console.error("❌ Error loading public env:", err);
      }
    }
    
    // Call it before your app initializes
    loadPublicEnv();
    return (
      <HashRouter>
        <Switch>

{selectedFarm === "PASHA" &&  <Route exact path="/" name="WeatherPasha" component={WeatherPasha} />}

{selectedFarm === "RAUKI" &&   <Route exact path="/" name="WeatherRauki" component={WeatherRauki} />}

{/* ✅ Catch-all redirect for any other route */}
<Redirect to="/" />
        {/* <Route exact path="/signup" name="Signup Page" component={SignupContainer} /> */}
        {/* <Route
          path="/airquality/:location"
          name="AirQuality"
          component={AirQuality}
        /> */}
        {/* <Route 
        exact path="/"
        name="Weather" 
        component={Weather} /> */}

          {/* <Route
            exact
            path="/airquality"
            name="AirQuality"
            component={AirQuality}
          />
          <Route
            exact
            path="/temperature"
            name="Temperature"
            component={AirQuality}
          />
          <Route
            exact
            path="/humidity"
            name="Humidity"
            component={AirQuality}
          />
          <Route exact path="/airquality/:location">
            <Redirect to="/" />
           </Route>
          <Route path="/barrage" name="Barrage" component={Barrage} />
          <Route path="/weather" name="Weather" component={Weather} />
          <Route path="/energy" name="Energy" component={Energy} /> */}
          {/* {/* <Route path="/" name="Home" component={Home} /> */}
        </Switch>
      </HashRouter>
    );
  }
}
const ClearCacheComponent = withClearCache(MainApp);

function App() {
  return <ClearCacheComponent />;
}

export default App;
